/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";

const DNVLoginComponentDisplay = () => {
    // const { instance } = useMsal();

    // const requestScopes = {
    //     scopes: ["https://dnvorgb2c.onmicrosoft.com/dnv-b2c-sample-api/tasks.read"],
    // };

    // const SignInRequest = {
    //     scopes: requestScopes.scopes,
    //     authority: "https://dnvorgb2c.b2clogin.com/dnvorgb2c.onmicrosoft.com/B2C_1_SignIn",
    // };

    // const SignUpRequest = {
    //     scopes: requestScopes.scopes,
    //     authority: "https://dnvorgb2c.b2clogin.com/dnvorgb2c.onmicrosoft.com/B2C_1_SignUp",
    // };

    const login = () => {
        // debug(webpage, model, error);
        // instance.loginRedirect(request).catch((e) => {
        //     console.log(e);
        // });
    };
    
    return (
        <div className='simplicity-customer-dnv'>
            <div className='button-wrapper'>
                <button className='btn' onClick={() => {
                    // return login(SignUpRequest)
                    return login();
                }}
                >
                    Sign up
                </button>
                or
                <button className='btn outline' onClick={() => {
                    // return login(SignInRequest)
                    return login();
                }}
                >
                    Log in
                </button>
            </div>
        </div>
    );
};

DNVLoginComponentDisplay.displayName = "DNVLoginComponentDisplay";
export { DNVLoginComponentDisplay };
